"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Call = void 0;
const tslib_1 = require("tslib");
const events_typed_1 = require("@video/events-typed");
const mediasoup_client_1 = require("mediasoup-client");
const qs_1 = tslib_1.__importDefault(require("qs"));
// eslint-disable-next-line import/no-cycle
const api_1 = require("../../../api");
const adapter_1 = require("../../../api/adapter");
const errors_1 = require("../../errors");
const errors_deprecated_1 = require("../../errors-deprecated");
const context_1 = require("../../utils/context/context");
const logger_1 = require("../../utils/logger");
const request_1 = tslib_1.__importDefault(require("../../utils/request/request"));
const common_1 = require("./common");
const messageList_1 = require("./messageList");
const peer_1 = require("./peer");
const stream_1 = tslib_1.__importDefault(require("./stream"));
const auth_core_1 = tslib_1.__importStar(require("../../utils/auth/auth-core"));
const common_2 = require("../../../utils/common");
const package_json_1 = tslib_1.__importDefault(require("../../../package-json"));
const gw_transport_1 = require("../../../v3/gateway/transport/gw-transport");
const bind_1 = require("../../utils/bind");
const NUM_STUN_SERVERS = 5;
const clientName = () => {
    var _a, _b, _c, _d, _e, _f;
    const mobile = adapter_1.device.isMobileDevice ? "mobile" : "desktop";
    if (adapter_1.device.isImplements(adapter_1.Feature.USER_AGENT_DATA) && ((_a = adapter_1.device.highEntropyValues) === null || _a === void 0 ? void 0 : _a.brands) != null) {
        const name = (_d = (_c = (_b = adapter_1.device.highEntropyValues) === null || _b === void 0 ? void 0 : _b.brands.map((item) => item.brand)) === null || _c === void 0 ? void 0 : _c.join("_")) !== null && _d !== void 0 ? _d : "browser-name-not-available";
        const cleanedName = name.replace(/[\W]+/g, "");
        return [cleanedName, adapter_1.device.platform, mobile].join("-");
    }
    const name = (_e = adapter_1.device.browserInfo.browserName) !== null && _e !== void 0 ? _e : "brand-not-available";
    const platform = (_f = adapter_1.device.platform) !== null && _f !== void 0 ? _f : "platform-not-available";
    return [name, platform, mobile].join("-");
};
/**
 * @internal
 */
class Call extends events_typed_1.EventEmitter {
    emit(event, ...args) {
        return super.emit(event, ...args);
    }
    get peer() {
        return this._peer;
    }
    get _iceServers() {
        return this.__iceServers;
    }
    get _edgeIceServers() {
        return this.__edgeIceServers;
    }
    get _iceTransportPolicy() {
        return this.__iceTransportPolicy;
    }
    get maxBitrate() {
        return this._maxBitrate;
    }
    get _requireRecv() {
        return this.__requireRecv;
    }
    get _requireSend() {
        return this.__requireSend;
    }
    get _closed() {
        return this.__closed;
    }
    get streams() {
        return this._streams;
    }
    get permissions() {
        return this._permissions;
    }
    get peerId() {
        return this._localPeerId;
    }
    get behaviours() {
        return this._behaviours;
    }
    // userShould checks the user's permission and behaviours to determine
    // if the user should perform an action
    userShould(permission) {
        if (!this.hasPermission(permission)) {
            return false;
        }
        return this._behaviours.includes(permission);
    }
    constructor(ctx, sfuJoinParams, joinCall, options = {}) {
        var _a, _b, _c, _d;
        super();
        this.setPreferredEncodingProcessing = false;
        this.callResolve = Promise.resolve;
        this.callReject = Promise.reject;
        this._startPromise = null;
        this._iceTransportPolicyUsed = null;
        //#endregion
        this.isDisposed = false;
        (0, bind_1.makeBounded)(this);
        this.ctx = ctx;
        (0, context_1.onceCanceled)(ctx).then((reason) => this.dispose(`VideoClient Context Cancelled: ${reason}`));
        ctx.logger.trace("constructor()", { options: options });
        // TODO: find all client options we want to send -
        // anything in the object will get sent to the MS3 SFU
        const { maxProducingViewers, auth } = options;
        this.options = {
            call: {
                maxProducingViewers,
            },
            auth,
        };
        this.gwTransport = new gw_transport_1.GwTransport(ctx);
        this.gwTransport.options({
            maxRetries: (_a = options.retries) !== null && _a !== void 0 ? _a : Infinity,
        });
        this.gwTransport.on("message:prepare-rejoin-call", this.onMessagePrepareRejoinCall);
        this.gwTransport.on("message:call-ended", this.onMessageCallEnded);
        this.gwTransport.on("message:callEnded", this.onMessageCallEnded);
        this.gwTransport.on("message:callError", this.onMessageCallError);
        this.gwTransport.on("message:disconnect", this.onMessageDisconnect);
        this.gwTransport.on("message:need-user", this.onMessageNeedUser);
        this.gwTransport.on("message:join-refresh", this.onMessageJoinRefresh);
        this.gwTransport.on("message:join-call-error", this.onMessageJoinCallError);
        this.gwTransport.on("message:call-rejected", this.onMessageCallRejected);
        this.gwTransport.on("message:callRejected", this.onMessageCallRejected);
        this.gwTransport.on("message:Forbidden", this.onMessageForbidden);
        this.gwTransport.on("message:call-refresh", this.onMessageCallRefresh);
        this.gwTransport.on("message:peerAtCapacity", this.onMessagePeerAtCapacity);
        this.gwTransport.on("message:producersKicked", this.onMessageProducersKicked);
        this.gwTransport.on("message:dominantSpeaker", this.onMessageDominantSpeaker);
        this.gwTransport.on("message:consumer-stats", this.onMessageConsumerStats);
        this.gwTransport.on("message:producer-stats", this.onMessageProducerStats);
        this.gwTransport.on("message:permissions", this.onMessagePermissions);
        this.gwTransport.on("message:options", this.onMessageOptions);
        this.gwTransport.on("message:ready", this.onMessageReady);
        this._maxBitrate = options.maxBitrate;
        this._messages = new messageList_1.MessageList();
        this._handleOffline = () => {
            this.emit("CALL_EMIT_MESSAGES", { messages: messageList_1.offlineMessages.messages });
        };
        this._handleOnline = () => {
            this.emit("CALL_EMIT_MESSAGES", { messages: messageList_1.offlineMessages.messages });
        };
        adapter_1.device.addEventListener("offline", this._handleOffline);
        adapter_1.device.addEventListener("online", this._handleOnline);
        if (sfuJoinParams.call == null) {
            throw new Error("join.call is undefined");
        }
        this.call = sfuJoinParams.call;
        this._userOverrides = options.user;
        this.user = {
            ...sfuJoinParams.user,
            ...this._userOverrides,
        };
        this._stunServers = (_d = (_c = (_b = this.call.stun) === null || _b === void 0 ? void 0 : _b.servers) === null || _c === void 0 ? void 0 : _c.map((x) => `stun:${x}`)) !== null && _d !== void 0 ? _d : [];
        this._stunIndex = NUM_STUN_SERVERS;
        this.__iceServers = () => {
            var _a, _b, _c, _d;
            if (this._stunIndex === 0 || this._stunServers.length === 0) {
                if (((_b = (_a = this.call.turn) === null || _a === void 0 ? void 0 : _a.servers) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return this.call.turn.servers;
                }
                return [];
            }
            const stun = [
                {
                    urls: this._stunServers.slice(this._stunIndex - NUM_STUN_SERVERS, this._stunIndex),
                },
            ];
            if (((_d = (_c = this.call.turn) === null || _c === void 0 ? void 0 : _c.servers) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                return this.call.turn.servers.concat(stun);
            }
            return stun;
        };
        this.__edgeIceServers = () => {
            var _a, _b;
            // edge only supports UDP turn
            const svrs = [];
            if (((_b = (_a = this.call.turn) === null || _a === void 0 ? void 0 : _a.servers) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                this.call.turn.servers.forEach((server) => {
                    if (Array.isArray(server.urls)) {
                        const urls = server.urls.filter((url) => url.startsWith("turn:"));
                        if ((urls === null || urls === void 0 ? void 0 : urls.length) > 0) {
                            svrs.push({
                                ...server,
                                urls: urls.map((url) => { var _a; return (_a = url.split("?")[0]) !== null && _a !== void 0 ? _a : ""; }),
                            });
                        }
                    }
                });
            }
            return svrs;
        };
        this._joinCall = joinCall;
        // The local peer's ID
        this._localPeerId = null;
        this.__iceTransportPolicy = options.iceTransportPolicy;
        this.__requireRecv = options.requireRecv === true;
        this.__requireSend = options.requireSend === true;
        this._flushLogs = !options.test;
        // Set when a media soup room is created
        this._iceTransportPolicyUsed = null;
        this._ip = null;
        this._permissions = [];
        this._behaviours = [];
        this._initialRun = true;
        this.__closed = false;
        this._startResolve = null;
        this._startPromise = null;
        this._serverOptions = null;
        this._stableTimeout = undefined;
        this._stable = null;
        this._streams = {};
        const { streams } = options;
        if (streams != null && Object.keys(streams).length > 0) {
            Object.keys(streams).forEach((streamName) => {
                const stream = streams[streamName];
                this.setStream(streamName, stream);
            });
        }
        else {
            this.ctx.logger.debug("Setting stream failed, there are no defined streams", { streams: streams });
        }
        this.setLogData();
    }
    get transport() {
        return this.gwTransport;
    }
    networkCheck(stats) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (this._stable != null) {
            if (stats.mediaType === "video") {
                if (((_c = (_b = (_a = this._serverOptions) === null || _a === void 0 ? void 0 : _a.call) === null || _b === void 0 ? void 0 : _b.defaultMinBitrate) !== null && _c !== void 0 ? _c : 0) > 0) {
                    if (((_d = stats.consumerBitrate) !== null && _d !== void 0 ? _d : 0) < ((_g = (_f = (_e = this._serverOptions) === null || _e === void 0 ? void 0 : _e.call) === null || _f === void 0 ? void 0 : _f.defaultMinBitrate) !== null && _g !== void 0 ? _g : 0)) {
                        if (this._stable.consumerBitrate === 0) {
                            this._stable.consumerBitrate = Date.now();
                        }
                        else if (Date.now() > ((_j = (_h = this._stable) === null || _h === void 0 ? void 0 : _h.consumerBitrate) !== null && _j !== void 0 ? _j : 0) + 1000) {
                            this._addMessage(messageList_1.TROUBLESHOOTING.UNSTABLE_NETWORK);
                        }
                    }
                    else {
                        delete this._stable.consumerBitrate;
                    }
                }
            }
        }
    }
    //#region Remote Messages Handlers
    onMessagePrepareRejoinCall() {
        for (const stream of this.streamsIterator()) {
            stream.close(false);
        }
    }
    onMessageCallEnded() {
        // TODO: should probably emit a new event
        this.close("call already ended on websocket", true).catch(this.ctx.logger.error);
        this.callResolve();
        this.ctx.logger.info("calls-core/call: end");
        this.emit("CALL_ENDED");
    }
    onMessageCallError(data) {
        var _a, _b;
        this.callReject(new errors_deprecated_1.CallError((_a = data.errorMessage) !== null && _a !== void 0 ? _a : "Unknown call error", { reason: data.reason }));
        if (data.reason === "sfu-busy") {
            this.emit("error", (0, errors_1.createError)(api_1.ErrorCode.SFUBusy, (_b = data.errorMessage) !== null && _b !== void 0 ? _b : "unknown reason", {}));
        }
        this.close("call error on websocket", true, true).catch(this.ctx.logger.error);
    }
    onMessageDisconnect() {
        this.emit("CALL_CONNECTING", false);
    }
    onMessageNeedUser() {
        this.gwTransport.send("user", this.user);
    }
    // update user and call on when a user re-joins a call.
    onMessageJoinRefresh(response) {
        if (response.body.call == null) {
            this.ctx.logger.error("response.body.call is undefined");
            return;
        }
        this.user = {
            ...response.body.user,
            ...this._userOverrides,
        };
        this.call = response.body.call;
    }
    onMessageJoinCallError(payload) {
        const inner = payload.error instanceof Error ? payload.error : null;
        const err = new errors_deprecated_1.JoinCallError("WS: Join Call Error", { inner });
        this.emit("error", err);
        this.callReject(err);
    }
    onMessageCallRejected() {
        this.ctx.logger.info("call rejected");
        const err = new errors_deprecated_1.CallError("WS: Call Rejected", { reason: "rejected" });
        this.emit("error", err);
        this.callReject(err);
        this.close("call was rejected by websocket", true).catch(this.ctx.logger.error);
    }
    onMessageForbidden() {
        this.ctx.logger.info("call ended - kicked");
        this.emit("CALL_FORBIDDEN");
        this.close("call ended - kicked (Forbidden)", true);
    }
    onMessageCallRefresh(call) {
        this.call = call;
    }
    onMessagePeerAtCapacity(producersAtCapacity) {
        const k = Object.keys(producersAtCapacity);
        this.emit("CALL_PEER_AT_CAPACITY", producersAtCapacity[k[0]]);
    }
    onMessageProducersKicked() {
        this.ctx.logger.info("Call ended - producers kicked");
        this.emit("CALL_PRODUCER_KICKED");
    }
    onMessageDominantSpeaker(dominantSpeaker) {
        this.ctx.logger.debug("websocket transport dominantSpeaker", {
            dominantSpeaker: dominantSpeaker,
        });
        this.emit("CALL_DOMINANT_SPEAKER", {
            userId: dominantSpeaker.userId,
            displayName: dominantSpeaker.displayName,
            peerId: dominantSpeaker.peerId,
            streamName: dominantSpeaker.streamName,
            producerId: dominantSpeaker.producerId,
        });
    }
    onMessageConsumerStats(stats) {
        this.networkCheck(stats);
        this.emit("CALL_SET_CONSUMER_STATS", {
            peerId: stats.peerId,
            streamName: stats.streamName,
            consumerId: stats.id,
            stats,
        });
    }
    onMessageProducerStats(stats) {
        this.networkCheck(stats);
        this.emit("CALL_SET_PRODUCER_STATS", {
            streamName: stats.streamName,
            producerId: stats.id,
            stats,
        });
    }
    onMessagePermissions(permissionsData) {
        this._permissions = permissionsData.permissions;
        this.emit("CALL_PERMISSIONS", {
            permissions: permissionsData.permissions,
        });
    }
    onMessageOptions(options) {
        this.ctx.logger.debug("websocket transport options", {
            options,
        });
        this._serverOptions = options;
        this.emit("CALL_OPTIONS", { options });
    }
    // resolve on ready state
    onMessageReady(readyData) {
        var _a, _b, _c, _d, _e, _f;
        if (process.env.NODE_ENV === "development") {
            // thar block should be removed in production mode by webpack/rollup/etc
            const sfuFailChance = adapter_1.device.globals.get("sfuFailChance");
            if (typeof sfuFailChance === "number" && Math.random() < sfuFailChance) {
                const err = new errors_deprecated_1.JoinCallError("DEBUG: Simulated SFU join error", {});
                this.callReject(err);
            }
        }
        this.emit("CALL_SFU_CONNECTION");
        if (this.__closed) {
            this.ctx.logger.debug("call: ready event fired after call was closed");
            this.gwTransport.finish();
            return;
        }
        this.ctx.logger.info("websocket transport ready", { readyData: readyData });
        this._ip = readyData.ip;
        this._localPeerId = readyData.peerId;
        this.ctx.logger.setMessageAggregate("peerId", this._localPeerId);
        if (((_a = readyData.permissions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this._permissions = readyData.permissions;
            this.emit("CALL_PERMISSIONS", { permissions: readyData.permissions });
        }
        if (((_b = readyData.behaviours) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this._behaviours = readyData.behaviours;
        }
        if (readyData.version === "v3" && this.user != null) {
            this.user.scope = readyData.scope;
            if (readyData.userId != null) {
                this.user.userId = readyData.userId;
            }
            if (readyData.displayName != null) {
                this.user.displayName = readyData.displayName;
            }
            this.clearLogData();
            this.setLogData();
        }
        this.emit("CALL_ROOM_DATA", {
            scope: (_d = (_c = this.user) === null || _c === void 0 ? void 0 : _c.scope) !== null && _d !== void 0 ? _d : "",
            peerId: readyData.peerId,
        });
        // save if the call is closed/closing before entering try/catch block
        const closed = this._closed || ((_e = this._peer) === null || _e === void 0 ? void 0 : _e._closed);
        this._request("options", this.options).catch((err) => {
            var _a;
            const currentlyClosed = this._closed || ((_a = this._peer) === null || _a === void 0 ? void 0 : _a._closed);
            const isPeerCloseError = !closed && currentlyClosed;
            //if the call was closed during async request sallow error
            if (!isPeerCloseError) {
                const inner = err instanceof Error ? err : null;
                this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", {
                    inner,
                    request: "options",
                    args: this.options,
                    internalCall: this,
                }));
            }
        });
        (_f = this._peer) === null || _f === void 0 ? void 0 : _f.dispose("Create a new peer after ws reconnection");
        this._peer = new peer_1.Peer((0, logger_1.extendContext)(this.ctx, peer_1.Peer), this);
        this._peer.on("error", (err) => {
            if (err.critical) {
                this.ctx.logger.error(`Peer error: ${err.code}; ${err.message}`, { err, call: this });
                this.close("peer error", true);
                this.callReject(err);
            }
            else {
                this.ctx.logger.warn(`Peer error: ${err.code}; ${err.message}`, { err, call: this });
            }
        });
        this._peer._setup(readyData.rtpCapabilities).then(() => {
            this.ctx.logger.debug("websocket ready", { rtpCapabilities: readyData.rtpCapabilities });
            this.emit("CALL_READY");
        });
    }
    dispose(reason) {
        this.close(`disposed: ${reason}`);
        this.isDisposed = true;
    }
    hasPermission(permission) {
        var _a;
        return (_a = this._permissions) === null || _a === void 0 ? void 0 : _a.includes(permission);
    }
    get streamNames() {
        return Object.keys(this._streams);
    }
    setStream(streamName, options) {
        this._streams[streamName] = new stream_1.default((0, logger_1.extendContext)(this.ctx, stream_1.default), streamName, this, options);
    }
    getStream(streamName) {
        return this._streams[streamName];
    }
    removeStream(streamName) {
        delete this._streams[streamName];
    }
    forEachStream(cb) {
        if (this._streams != null && Object.keys(this._streams).length > 0) {
            Object.keys(this._streams).forEach((streamName) => {
                cb(this._streams[streamName], streamName);
            });
        }
        else {
            this.ctx.logger.debug("Stream close() failed, there are no defined streams to close", {
                streams: this._streams,
            });
        }
    }
    *streamsIterator() {
        for (const k of Object.keys(this._streams)) {
            yield this._streams[k];
        }
    }
    setLogData() {
        var _a;
        this.ctx.logger.setMessageAggregate("callId", this.call.id);
        this.ctx.logger.setMessageAggregate("userId", this.user.userId);
        this.ctx.logger.setMessageAggregate("scope", (_a = this.user.scope) !== null && _a !== void 0 ? _a : "no scope");
        this.ctx.logger.setMessageAggregate("displayName", this.user.displayName);
    }
    clearLogData() {
        this.ctx.logger.removeMessageAggregate("callId");
        this.ctx.logger.removeMessageAggregate("peerId");
        this.ctx.logger.removeMessageAggregate("userId");
        this.ctx.logger.removeMessageAggregate("scope");
        this.ctx.logger.removeMessageAggregate("displayName");
        this.ctx.logger.removeMessageAggregate("recvTransportId");
        this.ctx.logger.removeMessageAggregate("recvTransportState");
        this.ctx.logger.removeMessageAggregate("sendTransportId");
        this.ctx.logger.removeMessageAggregate("sendTransportState");
    }
    _addMessage(msg) {
        this._messages.addMessage(msg);
        this.emit("CALL_EMIT_MESSAGES", { messages: messageList_1.offlineMessages.messages });
    }
    _removeMessage(msg) {
        this._messages.removeMessage(msg);
        this.emit("CALL_EMIT_MESSAGES", { messages: messageList_1.offlineMessages.messages });
    }
    get messages() {
        return this._messages.messages;
    }
    // should only be triggered externally and should be idempotent
    async close(debugString = "Implementer did not pass debugString", internal = false, hasError = false) {
        // used by the _run websocket disconnect handler to determine whether this was a user requested close
        if (this.__closed) {
            return null;
        }
        this.ctx.logger.info("Call Class, call closed()", {
            aggregates: { internal, reason: debugString },
        });
        if (this._flushLogs) {
            this.ctx.logger.flush();
        }
        if (this._peer != null) {
            await this._peer.close(debugString);
        }
        adapter_1.device.removeEventListener("offline", this._handleOffline);
        adapter_1.device.removeEventListener("online", this._handleOnline);
        this.__closed = true;
        this.forEachStream((s) => s.close());
        adapter_1.device.clearTimeout(this._stableTimeout);
        this._stable = null;
        this._cleanup(hasError);
        return Promise.resolve();
    }
    _cleanup(hasError = false) {
        // if hasError is true then we don't want to resolve the start promise
        // so this part **really** needs to be refactored
        if (!hasError && this._startResolve != null) {
            this._startResolve();
        }
        this.gwTransport.finish();
        this.emit("CALL_SET_ROOM_DONE");
        this.clearLogData();
    }
    async updateMaxBitrate(bitrate) {
        const args = { bitrate };
        try {
            await this._request("updateMaxBitrate", args);
            this._maxBitrate = bitrate;
        }
        catch (err) {
            const inner = err instanceof Error ? err : null;
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", {
                inner,
                request: "updateMaxBitrate",
                args,
                internalCall: this,
            }));
        }
    }
    setDisplayName(displayName) {
        this.ctx.logger.info("updating displayName", {
            displayName,
        });
        this.user.displayName = displayName;
        this.gwTransport.send("options", {
            peer: {
                displayName,
            },
        });
    }
    setMaxProducingViewers(maxProducingViewers) {
        this.ctx.logger.info("updating maxProducingViewers", {
            maxProducingViewers,
        });
        this.gwTransport.send("options", {
            call: {
                maxProducingViewers,
            },
        });
    }
    getViewers() {
        throw new Error("getViewers is deprecated");
    }
    async promoteViewer(userId, permissions, webhook = false) {
        var _a;
        if (!this.hasPermission(common_1.PERMISSIONS.CHANGE_PEER_SCOPE)) {
            this.ctx.logger.warn("viewer does not have permission to promote other viewers");
            throw new Error("no admin change scope permissions");
        }
        let response;
        const args = {
            userId,
            permissions,
            webhook,
        };
        try {
            response = await this._request("promote", args);
        }
        catch (err) {
            const inner = err instanceof Error ? err : null;
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", { inner, request: "promote", args, internalCall: this }));
            return;
        }
        this.emit("CALL_VIEWERS", { viewers: (_a = response.viewers) !== null && _a !== void 0 ? _a : [] });
    }
    async demoteViewer(userId, permissions, webhook = false) {
        var _a;
        if (!this.hasPermission(common_1.PERMISSIONS.CHANGE_PEER_SCOPE)) {
            this.ctx.logger.warn("viewer does not have permission to demote other viewers");
            throw new Error("no admin change scope permissions");
        }
        let response;
        const args = {
            userId,
            webhook,
            permissions,
        };
        try {
            response = await this._request("demote", args);
        }
        catch (err) {
            const inner = err instanceof Error ? err : null;
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", { inner, request: "demote", args, internalCall: this }));
            return;
        }
        this.emit("CALL_VIEWERS", { viewers: (_a = response.viewers) !== null && _a !== void 0 ? _a : [] });
    }
    // should really be called kickViewerProducers
    async kickViewer(userId, streamOnly, webhook = false) {
        var _a;
        if (!this.hasPermission(common_1.PERMISSIONS.CHANGE_PEER_SCOPE)) {
            this.ctx.logger.warn("viewer does not have permission to kick other viewers");
            throw new Error("no admin change scope permissions");
        }
        let response;
        const args = { userId };
        try {
            response = await this._request("kick", args);
        }
        catch (err) {
            const inner = err instanceof Error ? err : null;
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", { inner, request: "kick", args, internalCall: this }));
            return;
        }
        this.emit("CALL_VIEWERS", { viewers: (_a = response.viewers) !== null && _a !== void 0 ? _a : [] });
    }
    async kickPeer(peerId, streamOnly, webhook = false) {
        var _a;
        if (!this.hasPermission(common_1.PERMISSIONS.CHANGE_PEER_SCOPE)) {
            this.ctx.logger.warn("viewer does not have permission to kick other peers");
            throw new Error("no admin change scope permissions");
        }
        let response;
        const args = { peerId };
        try {
            response = await this._request("kick", args);
        }
        catch (err) {
            const inner = err instanceof Error ? err : null;
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", { inner, request: "kick", args, internalCall: this }));
            return;
        }
        this.emit("CALL_VIEWERS", { viewers: (_a = response.viewers) !== null && _a !== void 0 ? _a : [] });
    }
    async connect() {
        var _a, _b;
        this.emit("CALL_CONNECTING", true);
        this.gwTransport.finish();
        (_a = this._peer) === null || _a === void 0 ? void 0 : _a.peers.forEach((p) => {
            var _a;
            (_a = this._peer) === null || _a === void 0 ? void 0 : _a._onPeerClosed(p);
        });
        await ((_b = this._peer) === null || _b === void 0 ? void 0 : _b.dispose("Reconnecting"));
        this._peer = undefined;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            if (this.call.callUri == null) {
                this.emit("CALL_CONNECTING", false);
                throw new Error("callUri is undefined");
            }
            this.callResolve = resolve;
            this.callReject = reject;
            const [permitted, token] = await this.authJwt(this.options.auth);
            const options = {
                jwt: token !== null && token !== void 0 ? token : undefined,
            };
            if (!permitted) {
                this.emit("CALL_FORBIDDEN");
                this.close("call ended - jwt auth failed", true);
                return;
            }
            this.gwTransport
                .connect(this.call.callUri, options)
                .then(() => {
                this.emit("CALL_CONNECTING", false);
                this.emit("CALL_SET_CONNECTED", { connected: true });
            })
                .catch(reject);
        });
    }
    async authJwt(auth) {
        if (auth == null) {
            return [true, null];
        }
        try {
            const [token, isJwt] = await auth.requestAsync();
            if (!isJwt) {
                return [true, null];
            }
            return [true, token];
        }
        catch (err) {
            return [false, null];
        }
    }
    start() {
        this.ctx.logger.info("calls-core/call: start", {});
        if (this._startPromise != null) {
            this.ctx.logger.info("call: start has already been called");
            return this._startPromise;
        }
        this._startPromise = new Promise((resolve, reject) => {
            if (!this.ctx.support.any) {
                reject(new Error("Device is not supported"));
                return;
            }
            // will resolve when close is called
            this._startResolve = resolve;
            if (!this._initialRun) {
                this.emit("CALL_SET_CONNECTED", { connected: false });
                this.emit("CALL_EMIT_MESSAGES", {
                    messages: messageList_1.disconnectedMessages.messages,
                });
            }
            if (this.call.callUri == null) {
                reject(new Error("Call URI is undefined"));
                return;
            }
            this.connect()
                .then(() => {
                var _a;
                this._messages = new messageList_1.MessageList();
                this.emit("CALL_EMIT_MESSAGES", {
                    messages: (_a = this._messages.messages) !== null && _a !== void 0 ? _a : [],
                });
                this._initialRun = false;
            })
                .catch(reject);
        });
        return this._startPromise;
    }
    _setup(resolve, reject) {
        this.ctx.logger.debug("call setup");
    }
    async createProducer(track, options, appData) {
        var _a, _b;
        if (this._peer == null) {
            const msg = "creating a producer on a room which has not been set up";
            this.ctx.logger.warn(msg);
            throw new Error(msg);
        }
        // save if the call is closed/closing before entering try/catch block
        const closed = this._closed || ((_a = this._peer) === null || _a === void 0 ? void 0 : _a._closed);
        try {
            return await this._peer.produce(track, options, appData);
        }
        catch (err) {
            const currentlyClosed = this._closed || ((_b = this._peer) === null || _b === void 0 ? void 0 : _b._closed);
            const isPeerCloseError = !closed && currentlyClosed;
            //if the call was closed during async request sallow error
            if (!isPeerCloseError) {
                if (err instanceof mediasoup_client_1.types.InvalidStateError && err.message === "track ended") {
                    this.ctx.logger.warn("createProducer: track ended");
                }
                else {
                    this.ctx.logger.error(new errors_deprecated_1.MediasoupSetupError("createProducer: error creating producer", { inner: (0, errors_deprecated_1.wrapNativeError)(err) }));
                }
            }
            throw err;
        }
    }
    get _localSettings() {
        if (!adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE)) {
            return {};
        }
        const data = adapter_1.device.localStorage.getItem(`pvc:${this._ip}:settings`);
        if (data == null) {
            return {};
        }
        let settings;
        try {
            settings = JSON.parse(data);
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            this.ctx.logger.error("unable to parse settings", {
                data,
                err: msg,
            });
            return {};
        }
        return settings;
    }
    set _localSettings(settings) {
        if (!adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE)) {
            return;
        }
        // Prevent overwriting local development debug preference
        if (adapter_1.device.localStorage.getItem("debug") === "false") {
            return;
        }
        adapter_1.device.localStorage.setItem(`pvc:${this._ip}:settings`, JSON.stringify(settings));
    }
    async _request(type, data) {
        const response = await this.gwTransport.request(type, data);
        if (response == null) {
            const err = new Error("response is null");
            this.ctx.logger.warn("call _request", { err: err === null || err === void 0 ? void 0 : err.message });
            throw err;
        }
        return response;
    }
    async requestSources(streamName, peerId) {
        const args = { streamName, peerId };
        return this._request("consumerSources", args).catch((err) => {
            const inner = err instanceof Error ? err : null;
            if (err instanceof Error && err.message !== "request error: peer-closed") {
                this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", {
                    inner,
                    request: "consumerSources",
                    args,
                    internalCall: this,
                }));
            }
            return err;
        });
    }
    setPreferredEncoding(consumerId, id) {
        var _a;
        if (!((_a = this.peer) === null || _a === void 0 ? void 0 : _a.hasConsumerId(consumerId))) {
            this.emit("error", new errors_deprecated_1.ConsumerNotFoundError("consumer not found for consumer event", { consumerId }));
            return;
        }
        if (this.setPreferredEncodingProcessing) {
            this.ctx.logger.warn("setPreferredEncoding already processing", { consumerId, id });
            return;
        }
        const args = { consumerId, id };
        this.setPreferredEncodingProcessing = true;
        this._request("setPreferredEncoding", args)
            .catch((err) => {
            var _a;
            const inner = err instanceof Error ? err : null;
            if (this._consumerNotFoundError(consumerId, inner)) {
                // If the consumerId still exists in VDC but not on server, issue a warning rather than an error
                if ((_a = this.peer) === null || _a === void 0 ? void 0 : _a.hasConsumerId(consumerId)) {
                    this.ctx.logger.warn("consumer does not exist on server, but still exists in videoclient", {
                        err: err === null || err === void 0 ? void 0 : err.message,
                        consumerId,
                    });
                }
                // If consumerId does not exist in VDC or server, ignore this error.
                return;
            }
            this.emit("error", new errors_deprecated_1.WSRequestError("ws request error", {
                inner,
                request: "setPreferredEncoding",
                args,
                internalCall: this,
            }));
        })
            .finally(() => {
            this.setPreferredEncodingProcessing = false;
        });
    }
    _consumerNotFoundError(consumerId, err) {
        if (err == null || (err === null || err === void 0 ? void 0 : err.message) !== "request error: consumer not found") {
            return false;
        }
        return true;
    }
    async setVideoStreamProvider(streamName, streamProvider, options, execute, preview = false) {
        if (this._streams[streamName] == null) {
            const msg = "setVideoStreamRetriever on invalid stream";
            this.ctx.logger.error(msg);
            throw new Error(msg);
        }
        return this._streams[streamName].setVideoStreamProvider(streamProvider, options, execute, preview);
    }
    async setAudioStreamProvider(streamName, streamProvider, options, execute, preview = false) {
        if (this._streams[streamName] == null) {
            const msg = "setAudioStreamRetriever on invalid stream";
            this.ctx.logger.error(msg);
            throw new Error(msg);
        }
        return this._streams[streamName].setAudioStreamProvider(streamProvider, options, execute, preview);
    }
    muteAudio(streamName) {
        if (this._streams[streamName] == null) {
            const msg = "muteAudio on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        this._streams[streamName].pauseAudio();
    }
    async unmuteAudio(streamName, options = {}) {
        if (this._streams[streamName] == null) {
            const msg = "unmuteAudio on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        return this._streams[streamName].enableAudio(options, false);
    }
    disableAudio(streamName) {
        if (this._streams[streamName] == null) {
            const msg = "disableAudio on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        this._streams[streamName].disableAudio();
    }
    async enableAudio(streamName, refresh, preview = false, options = {}) {
        this.ctx.logger.debug("enable audio", { streamName, refresh });
        if (this._streams[streamName] == null) {
            const msg = "enableAudio on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        return this._streams[streamName].enableAudio(options, refresh, preview);
    }
    // eslint-disable-next-line consistent-return
    async enableVideo(streamName, refresh, preview = false, options = {}) {
        if (!options.audioOnly) {
            this.ctx.logger.debug("enable video", { streamName, refresh });
            if (this._streams[streamName] == null) {
                const msg = "enableVideo on invalid stream";
                this.ctx.logger.error(msg, {
                    streamName,
                });
                throw new Error(msg);
            }
            return this._streams[streamName].enableVideo(options, refresh, preview);
        }
        this.ctx.logger.debug("enable video", { streamName, refresh });
    }
    disableVideo(streamName) {
        if (this._streams[streamName] == null) {
            const msg = "disableVideo on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        this._streams[streamName].disableVideo();
    }
    async unpauseVideo(streamName, options = {}) {
        if (this._streams[streamName] == null) {
            const msg = "unpauseVideo on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        return this._streams[streamName].enableVideo(options, false);
    }
    pauseVideo(streamName) {
        this.ctx.logger.debug("calls-core/call: pause video");
        if (this._streams[streamName] == null) {
            const msg = "pauseVideo on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        return this._streams[streamName].pauseVideo();
    }
    // _pauseProducer pauses server side producer
    _pauseProducer(producerId, streamName) {
        this.gwTransport
            .request("pauseProducer", {
            producerId,
        })
            .catch((err) => {
            this.ctx.logger.warn("call.pauseProducer: error pausing server producer", err);
        });
        this.emit("CALL_SET_PRODUCER_PAUSED", {
            streamName,
            producerId,
            originator: "client",
        });
    }
    // _resumeProducer resumes server site producer
    _resumeProducer(producerId, streamName) {
        this.gwTransport
            .request("resumeProducer", {
            producerId,
        })
            .catch((err) => {
            this.ctx.logger.warn("call.resumeProducer: error resuming server producer", err);
        });
        this.emit("CALL_SET_PRODUCER_RESUMED", {
            streamName,
            producerId,
            originator: "client",
        });
    }
    // _closeProducer closes server side producer
    _closeProducer(producerId, streamName) {
        this.gwTransport
            .request("closeProducer", {
            producerId,
        })
            .catch((err) => {
            this.ctx.logger.warn("call.closeProducer: error closing server producer", { err: `${err}`, producerId });
        });
        this.emit("CALL_REMOVE_PRODUCER", {
            streamName,
            producerId,
            originator: "client",
        });
    }
    async hotswapProducer(kind, streamName, producerOptions) {
        this.ctx.logger.debug("calls-core/call: hotswwap producer");
        if (this._streams[streamName] == null) {
            const msg = "hotswapProducer on invalid stream";
            this.ctx.logger.error(msg, {
                streamName,
            });
            throw new Error(msg);
        }
        await this._streams[streamName].hotswapProducer(kind, producerOptions);
    }
    toJSON() {
        return {
            streamNames: this.streamNames,
            peer: this._peer,
            aggregates: {
                support: this.ctx.support.hash,
                url: this.call.callUri,
                callId: this.call.id,
                userId: this.user.userId,
                peerId: this.peerId,
                isConnected: this.gwTransport.isConnected,
            },
        };
    }
}
exports.Call = Call;
Call.displayName = "PvcCall";
const callSfuUri = (ctx, call, token, options) => {
    var _a;
    const q = {
        support: ctx.support.hash,
        client_name: clientName(),
        client_version: (_a = adapter_1.device.appVersion) !== null && _a !== void 0 ? _a : "",
        vdcVersion: package_json_1.default.version,
    };
    const debug = adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE)
        ? adapter_1.device.localStorage.getItem("pvc:debug") === "true"
        : false;
    if (debug) {
        q.debug = true;
    }
    if (typeof token === "string" && token.length > 0 && !(0, auth_core_1.isJwtToken)(token)) {
        q.t = token;
    }
    if (options.test) {
        q.t = "test";
    }
    if (options.displayName != null) {
        q.displayName = options.displayName;
    }
    if (options.sendAudio === false && options.sendVideo !== false) {
        q.videoOnly = true;
    }
    else if (options.sendAudio !== false && options.sendVideo === false) {
        q.audioOnly = true;
    }
    // xcode options
    if (options.rsrc != null) {
        q.rsrc = options.rsrc;
    }
    if (options.xkey != null) {
        q.xkey = options.xkey;
    }
    if (options.bpeerId != null) {
        q.bpeerId = options.bpeerId;
    }
    if (options.suspendPlay) {
        q.sp = true;
    }
    // can be deprecated after
    if (options.user != null) {
        q.udata = true;
    }
    return `${call.sfu.uri}/v3/${call.id}?${qs_1.default.stringify(q)}`;
};
exports.default = async (ctx, id, joinUrl, options, callInstance, sfuJoinParams = null) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    ctx.logger.debug("joining call", { id, options: options });
    // Avoid mutating provided args
    const callOptions = { ...options };
    const opts = {
        method: "post",
        callId: id,
        failoverUrls: options.failoverUrls,
    };
    if (callOptions.auth != null) {
        opts.auth = callOptions.auth;
    }
    if (callOptions.authOptions != null) {
        opts.auth = new auth_core_1.default(callOptions.authOptions);
    }
    opts.query = {};
    const context = (0, common_2.contextId)();
    if (context != null) {
        opts.query.contextId = context;
    }
    const instance = (0, common_2.instanceId)();
    if (instance != null) {
        opts.query.instanceId = instance;
    }
    if (((_a = callOptions.sfu) === null || _a === void 0 ? void 0 : _a.id) != null) {
        opts.query.id = (_b = callOptions.sfu) === null || _b === void 0 ? void 0 : _b.id;
    }
    if (((_c = callOptions.sfu) === null || _c === void 0 ? void 0 : _c.region) != null) {
        opts.query.region = (_d = callOptions.sfu) === null || _d === void 0 ? void 0 : _d.region;
    }
    if (((_e = callOptions.sfu) === null || _e === void 0 ? void 0 : _e.version) != null) {
        opts.query.version = (_f = callOptions.sfu) === null || _f === void 0 ? void 0 : _f.version;
    }
    if (((_g = callOptions.sfu) === null || _g === void 0 ? void 0 : _g.pool) != null) {
        opts.query.pool = (_h = callOptions.sfu) === null || _h === void 0 ? void 0 : _h.pool;
    }
    const body = {
        sfu: {
            msVersion: [3],
        },
    };
    if (callOptions.sfu != null) {
        body.sfu = { ...callOptions.sfu, msVersion: [3] };
    }
    opts.body = JSON.stringify(body);
    const joinCall = async (joinOptions = {}) => {
        var _a;
        ctx.logger.debug("calls-core/call:joinCall");
        try {
            const response = await (0, request_1.default)(ctx, joinUrl, {
                ...opts,
                ...joinOptions,
                warnStatuses: [404, 422],
            });
            if (((_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.call) == null) {
                throw new Error("response is null or incorrect");
            }
            response.body.call.callUri = callSfuUri(ctx, response.body.call, response.authToken, callOptions);
            ctx.logger.debug("joinCall() response", { response: response });
            callInstance.emit("callJoinEndpoint");
            return response;
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            if (err instanceof Response) {
                if (err.status === 404) {
                    ctx.logger.warn("sfu unavailable", {
                        id,
                        joinUrl,
                        err: msg,
                    });
                }
                else if (err.status === 503) {
                    ctx.logger.error("unable to join a call - no sfus available", {
                        id,
                        joinUrl,
                        err: msg,
                    });
                }
            }
            else {
                ctx.logger.warn("unable to get sfu uri", {
                    id,
                    joinUrl,
                    err: msg,
                });
            }
            throw err;
        }
    };
    let newSFUJoinParams;
    if ((sfuJoinParams === null || sfuJoinParams === void 0 ? void 0 : sfuJoinParams.call) != null) {
        sfuJoinParams.call.callUri = callSfuUri(ctx, sfuJoinParams.call, sfuJoinParams.user.authorizeToken, callOptions);
        newSFUJoinParams = sfuJoinParams;
        setTimeout(() => callInstance.emit("callJoinEndpoint"), 0);
    }
    else {
        newSFUJoinParams = (await joinCall()).body;
    }
    return new Call((0, logger_1.extendContext)(ctx, Call), newSFUJoinParams, joinCall, callOptions);
};
//# sourceMappingURL=call.js.map